import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { successToast, errorToast } from "../Utils/toast";
import { closeModal } from "../redux/features/modalSlice";
import { useChangeStatusMutation } from "../redux/services/CommonApi/changeStatusApis";
import {Faplus} from 'react-icons/fa';
function StatusModal({
  title,
  message,
  apiUrl,
  id,
  currentStatus,
}) {

  const dispatch = useDispatch();
 const [changeStatus] = useChangeStatusMutation();
  const [loading, setLoading] = useState(false);
 const handleStatusChange = async () => {
    try {
      setLoading(true);
       const res = await changeStatus({
        url: apiUrl,
        id,
      }).unwrap();

      successToast(res?.message || "Status updated successfully");

      dispatch(closeModal());

    } catch (error) {
      console.log(error);

      errorToast(
        error?.data?.message ||
        error?.message ||
        "Status update failed"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="custom-modal-body text-center">
        <div className="model-custum">
          <div className="status-icon">
            <h1>
              🔄
            </h1>
          </div>

          <h3>
            {title}
          </h3>

          <p className="delete-text">
            {message}
          </p>

          <div
            className={
              currentStatus === "Active"
                ? "view-status-badge active-badge"
                : "view-status-badge inactive-badge"
            }
          >

            Current Status :
            {" "}
            {currentStatus}

          </div>

        </div>

      </div>

      <div className="modal-btn-group justify-content-center">

        <button
          className="cancel-btn"
          onClick={() => dispatch(closeModal())}
        >
          Cancel
        </button>

        <button
          className="save-btn"
          onClick={handleStatusChange}
          disabled={loading}
        >
          {
            loading
              ? "Updating..."
              : "Change Status"
          }
        </button>

      </div>
    </>
  );
}

export default StatusModal;


